/**
* Created by lobin on 2020/7/23.
*/
<template>
	<div class="station-check">
		<a-card :body-style="{padding: '24px 32px'}" :bordered="false">
			<a-steps :current="current">
				<a-step v-for="item in steps" :key="item.title" :title="item.title">
					<template slot="title">
						{{ item.title }}
					</template>
					<span slot="description">{{ item.content }}</span>
				</a-step>
			</a-steps>
			<div class="" v-if="current === 0">
				<a-result v-if="!dtuchecked">
					<template #title>
						<p>站点编号：{{ detail.serial }}</p>
						<p>dut心跳：{{ detail.heartbeat }}</p>
						<p>dutMac：{{ detail.mac }}</p>
					</template>
					<template #extra>
						<a-button key="console" type="primary" @click="checkDtu">资料确认开始检查</a-button>
					</template>
				</a-result>
				<div style="width: 50%;margin: 0 auto;" v-else>
					<a-result :status="dtucheckResult" title="链接检查结果">
						<template #extra>
							<a-button key="console" type="primary" @click="next">下一步</a-button>
							<a-button key="buy" @click="checkDtu">重试</a-button>
						</template>
						<div class="desc">
							<p style="font-size: 16px;">
								<strong>检查失败请调整参数重试</strong>
							</p>
							<p>
								<a-icon :style="{ color: 'green' }" type="check-circle" v-if="dtucheckRes.socket.success" />
								<a-icon :style="{ color: 'red' }" type="close-circle" v-else />
								{{ dtucheckRes.socket.msg }}
							</p>
							<p>
								<a-icon :style="{ color: 'green' }" type="check-circle" v-if="dtucheckRes.heartbeat.success" />
								<a-icon :style="{ color: 'red' }" type="close-circle" v-else />
								{{ dtucheckRes.heartbeat.msg }}
							</p>
						</div>
					</a-result>
				</div>
			</div>
			<div class="" v-if="current === 1" style="width: 50%;margin: 0 auto;">
				<a-result
					:status="bordchecking ? 'info' : bordercheckResult ? 'success' : 'error'"
					:title="bordchecking ? '开始检查主板...' : bordercheckResult ? '主板检查成功' : '主板检测失败'">
					<template #extra>
						<a-button key="console" type="primary" @click="next">下一步</a-button>
						<a-button key="buy" @click="cheBordRe">重试</a-button>
					</template>
					<div class="desc">
						<p style="font-size: 16px;">
							<strong>主板失败请查看主板连接是否正常</strong>
						</p>
						<p v-for="(item, index) in bordcheckRes" :key="index">
							<a-icon :style="{ color: 'green' }" type="check-circle" v-if="item.result" />
							<a-icon :style="{ color: 'red' }" type="close-circle" v-else />
							<strong>{{ item.cabNum }}</strong>号主板{{ item.msg }}
						</p>
					</div>
				</a-result>
			</div>
			<div class="" v-if="current === 2">
				<a-result v-if="!cabinetChecked">
					<template #title>
						<p>格子检测会批量开箱请注意</p>
					</template>
					<template #extra>
						<a-button key="console" type="primary" @click="checkCabint">开始检查</a-button>
					</template>
				</a-result>
				<div style="width: 70%;margin: 0 auto;" v-else>
					<a-result :status="cabinetChecking ? 'info' : cabinetChecStatu" :title="cabinetChecking ? '柜子检测中请耐心等待...' : '检测结束'">
						<template #extra>
							<a-button key="console" type="primary" @click="comfirm">测试完成</a-button>
							<a-button key="buy" @click="checkCabinet">重试</a-button>
						</template>
						<div class="desc">
							<a-table
								:columns="columns"
								:loading="cabinetChecking"
								:data-source="cabinetCheckResList"
								:pagination="{ pageSize: 50 }"
								:scroll="{ y: 240 }"
							>
								<span slot="success" slot-scope="text">
				          <a-tag color="green" v-if="text">成功</a-tag>
									<a-tag color="red" v-else>失败</a-tag>
				        </span>
								<span slot="checkRes" slot-scope="text">
				          <a-tag color="green" v-if="text">成功</a-tag>
									<a-tag color="red" v-else>失败</a-tag>
				        </span>
							</a-table>
						</div>
					</a-result>
				</div>
			</div>
		</a-card>
	</div>
</template>

<script type="text/babel">
import {
  stationDetail,
  dtucheck,
  mainboardcheck,
  checAllCabinet,
} from '@/api/station';

const columns = [
  {
    title: '编号',
    dataIndex: 'serial',
    width: 150,
  },
  {
    title: '通道',
    dataIndex: 'channel',
    width: 150,
  },
  {
    title: '组',
    dataIndex: 'bord',
  },
  {
    title: '发送结果',
    dataIndex: 'success',
	  scopedSlots: { customRender: 'success' },
  },
  {
    title: '查询结果',
    dataIndex: 'checkRes',
	  scopedSlots: { customRender: 'checkRes' },
  },
];

export default {
  data() {
    return {
	    columns,
      current: 0,
	    detail: {},
	    dtuchecked: false,
	    bordchecking: false,
	    bordcheckRes: [],
		  dtucheckRes: {
        socket: {},
			  heartbeat: {},
		  },
	    cabinetCheckResList: [],
	    cabinetChecking: false,
	    cabinetChecked: false,
      steps: [
        {
          title: '第一步',
          content: '站点资料及DTU检测',
        },
        {
          title: '第二步',
          content: '检测主板',
        },
        {
          title: '第三步',
          content: '检测格子',
        },
      ],
    };
  },
  created() {
  	this.id = this.$route.params.id;
  	this.getDetail();
  },
  computed: {
	  dtucheckResult() {
	  	return this.dtucheckRes.socket.success && this.dtucheckRes.heartbeat.success ? 'success' : 'error';
	  },
    bordercheckResult() {
	  	let res = true;
	  	for (let i = 0; i < this.bordcheckRes.length; i++) {
        if (!this.bordcheckRes[i].result) {
          res = false;
        }
		  }
	  	return res;
    },
	  cabinetChecStatu() {
	    let res = true;
	    for (let i = 0; i < this.cabinetCheckResList.length; i++) {
	    	const item = this.cabinetCheckResList[i];
	    	if (!item.success || !item.checkRes) {
	    		res = false;
	    		break;
		    }
	    }
	    return res ? 'success' : 'error';
	  },
  },
  methods: {
  	async getDetail() {
  		const { data } = await stationDetail(this.id);
  		this.detail = data;
	  },
	  next() {
  		const { current, dtucheckResult, bordercheckResult } = this;
  		if (current === 0 && dtucheckResult === 'error') {
  			return this.$message.error('检查不通过不能进行下一步');
		  }
	    if (current === 0 && dtucheckResult === 'success') {
	      this.cheBord();
	    }
	    if (current === 1 && !bordercheckResult) {
		    return this.$message.error('检查不通过不能进行下一步');
	    }
	    if (current === 1 && bordercheckResult) {
		    this.checkCabinet();
	    }
		  this.current++;
	  },
    async checkDtu() {
  		const { data } = await dtucheck(this.detail._id);
  		this.dtucheckRes = data;
      this.dtuchecked = true;
    },
	  cheBordRe() {
  		this.bordcheckRes = [];
  		this.cheBord();
	  },
    async cheBord() {
  		this.bordchecking = true;
  		const cabnum = this.detail.cabinetNums;
  		const id = this.detail._id;
  		for (let i = 0; i < cabnum; i++) {
  			const { data } = await mainboardcheck(id, i + 1);
  			this.bordcheckRes.push(data);
		  }
      this.bordchecking = false;
    },
	  checkCabint() {
  		this.$confirm({
		  content: '确认要检测，将会打开全部柜子?',
		  onOk: () => {
				  	this.checkCabinet();
				  },
		  });
	  },
    async checkCabinet() {
  		this.cabinetChecking = true;
	    this.cabinetChecked = true;
	    const { data } = await checAllCabinet(this.detail._id);
  		this.cabinetCheckResList = data;
	    this.cabinetChecking = false;
    },
	  comfirm() {
  		if (this.cabinetChecStatu === 'error') {
  			return this.$message.fail('格子检测失败，请重试');
		  }
  		this.$router.go(-1);
	  },
  },
};
</script>

<style lang="less" rel="stylesheet/less">
	.station-check {

	}
</style>
